import { humanizeLargeNumber } from 'utils'

const FormatedTableCell = ({ value, digit = 2 }) => {
  if (value === -1) return '--'

  return humanizeLargeNumber(value, digit)
}

export default FormatedTableCell
